/**
 * @module types/settings/dualAxis
 * @description 双 Y 轴存储（字段 `primaryYAxis` / `secondYAxis`）
 *
 * 折线双轴与组合图轴对象形状不同，归一化见 `settingGroups/common/DualAxis/axisMetricUtils.ts`。
 * Schema 缺省为冻结空对象；UI 空态由各自 `normalize*FromStorage` 补全。
 */

export type TAxisKey = 'primaryYAxis' | 'secondYAxis';

export type TAxisMetric = {
  metric: string;
  tableCode: string;
};

/** 组合图 · 单指标轴（提交 metric 为 string） */
export interface IMixedAxisConfig {
  yAxisName?: string;
  metric?: string;
  chartType?: string;
  yAxisRangeSwitch?: boolean;
}

/** 折线双轴 · 多指标轴（提交 metrics 为数组） */
export interface ILineDualAxisConfig {
  yAxisName?: string;
  metrics?: TAxisMetric[];
  chartType?: string;
  yAxisRangeSwitch?: boolean;
}

/** 存储层：未归一前允许折线/组合两种对象之一 */
export type TYAxisAxisStorage = IMixedAxisConfig | ILineDualAxisConfig;

/**
 * primaryYAxis 缺省（未落库）
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.primaryYAxis 为同一引用
 */
export const PRIMARY_Y_AXIS_DEFAULT: TYAxisAxisStorage = Object.freeze(
  {},
) as TYAxisAxisStorage;

/**
 * secondYAxis 缺省（未落库）
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.secondYAxis 为同一引用
 */
export const SECOND_Y_AXIS_DEFAULT: TYAxisAxisStorage = Object.freeze(
  {},
) as TYAxisAxisStorage;
